import { SVGProps, Ref, forwardRef } from 'react';

export const DotsOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M6 3c-.75 0-1 .5-1 1s.25 1 1 1 1-.5 1-1-.25-1-1-1" fill="currentColor" />
            <path d="M6 7c-.75 0-1 .5-1 1s.25 1 1 1 1-.5 1-1-.25-1-1-1" fill="currentColor" />
            <path d="M5 12c0-.5.25-1 1-1s1 .5 1 1-.25 1-1 1-1-.5-1-1" fill="currentColor" />
            <path d="M10 3c-.75 0-1 .5-1 1s.25 1 1 1 1-.5 1-1-.25-1-1-1" fill="currentColor" />
            <path d="M9 8c0-.5.25-1 1-1s1 .5 1 1-.25 1-1 1-1-.5-1-1" fill="currentColor" />
            <path d="M10 11c-.75 0-1 .5-1 1s.25 1 1 1 1-.5 1-1-.25-1-1-1" fill="currentColor" />
        </g>
    </svg>
));
DotsOutlinedSize16Glyph.displayName = 'DotsOutlinedSize16Glyph';
